import React from "react";
import { motion } from "framer-motion";
import jobique from "../assets/jobique_project.png";

const Card5 = () => {
  return (
    <motion.div
      initial={"hidden"}
      whileInView={"visible"}
      variants={{
        visible: { opacity: 1 },
        hidden: { opacity: 0 },
      }}
      className="max-w-xl bg-white rounded-lg border border-gray-200 shadow-lg bg-gray-100 dark:border-gray-700 my-8"
    >
      <a
        href="https://jobique.vercel.app/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className="rounded-t-lg w-full"
          src={jobique}
          alt="Jobique project home page"
        />
      </a>
      <div className="p-5">
        <a
          href="https://github.com/nick3948/Jobique"
          target="_blank"
          rel="noopener noreferrer"
        >
          <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-black hover:text-blue-500 transition-colors duration-300 cursor-pointer">
            Jobique
          </h5>
        </a>
        <p className="mb-3 font-normal text-gray-700 dark:text-black-400">
          Developed a full-stack job tracking platform using Next.js, TypeScript, and PostgreSQL, featuring AWS S3-based document storage, secure Clerk authentication, and OpenAI integration for automated networking outreach.
        </p>
      </div>
    </motion.div>
  );
};

export default Card5;
